/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import './style.scss';
import {
  Table, Select, notification,
} from 'antd';
import { v4 as uuidv4 } from 'uuid';
import TenantActions from '@Actions/tenantActions';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import BusyIntegrationActions from '../../../../../../../actions/integrations/busyIntegrationAction';
import BusyTabLoading from '../../BusyTabLoading';
import PRZSelect from '../../../../../../Common/UI/PRZSelect';

const { Option } = Select;

/**
 *
 */
const BusyMapLocations = ({
  user, getTenants, getTenantsLoading, tenants, connectToBusyLocationLoading,
  setStep, getBusyConnections, connectToBusyLocation, getBusyConnectionsLoading,
  integrationBusyId, busyConnection, stepNumber,
}) => {
  const [tenantMapping, setTenantMapping] = useState([]);
  const [selectedBusyConnection, setSelectedBusyConnection] = useState('');

  useEffect(() => {
    setSelectedBusyConnection(busyConnection);
    setTenantMapping(busyConnection?.tenant_mapping);
  }, [busyConnection]);

  const updateTableValue = (key, value, label) => {
    const data = tenantMapping.map((tenant) => {
      if (tenant.tenant_id === key) {
        // eslint-disable-next-line no-param-reassign
        tenant[label] = value;
        return tenant;
      }
      return tenant;
    });
    setTenantMapping(data);
  };

  if (getBusyConnectionsLoading || !selectedBusyConnection) return <BusyTabLoading />;

  const columns = [
    {
      title: 'Procuzy Location',
      render: (record) => (
        <div>
          {record?.tenant_name}
        </div>
      ),
    },
    {
      title: 'Location',
      width: '164px',
      render: (record) => (
        <div style={{ width: '150px' }}>
          <PRZSelect
            value={record.busy_location_name}
            filterOption={false}
            onChange={(value) => {
              updateTableValue(record?.tenant_id, value, 'busy_location_name');
            }}
            placeholder="Select a location"
            disabled={connectToBusyLocationLoading || getBusyConnectionsLoading}
          >
            {busyConnection?.available_locations
              ?.map((item) => (
                <Option key={item.name} value={item.name}>
                  {item?.name}
                </Option>
              ))}
          </PRZSelect>
        </div>
      ),
    },
    selectedBusyConnection?.sales_voucher_integration ? {
      title: 'Sales Voucher Series',
      render: (record) => (
        <div>
          <PRZSelect
            value={record.sale_voucher_series}
            filterOption={false}
            onChange={(value) => {
              updateTableValue(record?.tenant_id, value, 'sale_voucher_series');
            }}
            placeholder="Select a Sales Voucher Series"
            disabled={connectToBusyLocationLoading || getBusyConnectionsLoading}
          >
            {(selectedBusyConnection?.voucher_series_master_list?.sales_voucher_series || []).map((series) => (
              <Option key={series.name} value={series.name}>
                {series.name}
              </Option>
            ))}
          </PRZSelect>
        </div>
      ),
    } : null,
    selectedBusyConnection.purchase_voucher_integration ? {
      title: 'Purchase Voucher Series',
      render: (record) => (
        <div>
          <PRZSelect
            value={record.purchase_voucher_series}
            filterOption={false}
            onChange={(value) => {
              updateTableValue(record?.tenant_id, value, 'purchase_voucher_series');
            }}
            placeholder="Select a Purchase Voucher Series"
            disabled={connectToBusyLocationLoading || getBusyConnectionsLoading}
          >
            { (selectedBusyConnection?.voucher_series_master_list?.purchase_voucher_series || []).map((series) => (
              <Option key={series.name} value={series.name}>
                {series.name}
              </Option>
            ))}
          </PRZSelect>
        </div>
      ),
    } : null,

  ].filter((i) => i);

  const handleSubmit = () => {
    if (tenantMapping?.length > 0) {
      const _tenantMapping = tenantMapping?.filter((obj) => obj.busy_location_name !== undefined && obj.busy_location_name !== null);
      const payload = {
        integration_busy_id: selectedBusyConnection.integration_busy_id,
        tenant_mapping: _tenantMapping,
      };
      connectToBusyLocation(payload, () => {
        getBusyConnections(user?.tenant_info?.org_id, () => setStep(Number(stepNumber) + 1));
      });
    } else {
      notification.error({
        message: 'Please select at least one location',
        placement: 'top',
        duration: 4,
      });
    }
  };

  return (
    <div className="busy__location-wrapper">
      <div className="ant-row">
        <div className="ant-col-md-23">
          <Table
            columns={columns}
            loading={getTenantsLoading || connectToBusyLocationLoading || getBusyConnectionsLoading}
            dataSource={tenantMapping}
            size="small"
            pagination={false}
            scroll={{ y: 400, x: 0 }}
            bordered
          />
        </div>
      </div>
      <div className="ant-row" style={{ display: 'flex', marginTop: '20px' }}>
        <div>
          <H3Button
            text="Save and Continue"
            buttonType={defaultButtonTypes.BLUE_ROUNDED}
            onClick={() => handleSubmit()}
            customClass="busy__location-submit"
            isLoading={connectToBusyLocationLoading || getBusyConnectionsLoading}
            disabled={connectToBusyLocationLoading || getBusyConnectionsLoading}
          />
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = ({
  UserReducers, TenantReducers, BusyIntegrationReducers,
}) => ({
  user: UserReducers.user,
  tenants: TenantReducers.tenants,
  connectToBusyLocationLoading: BusyIntegrationReducers.connectToBusyLocationLoading,
  getBusyConnectionsLoading: BusyIntegrationReducers.getBusyConnectionsLoading,
  getTenantsLoading: TenantReducers.getTenantsLoading,
});
const mapDispatchToProps = (dispatch) => ({
  getTenants: (page, keyword, isVerified, orgId) => dispatch(
    TenantActions.getTenants(page, keyword, isVerified, orgId),
  ),
  getBusyConnections: (orgId, callback) => dispatch(BusyIntegrationActions.getBusyConnections(orgId, callback)),
  connectToBusyLocation: (payload, callback) => dispatch(BusyIntegrationActions.connectToBusyLocation(payload, callback)),
});

BusyMapLocations.propTypes = {
  user: PropTypes.any,
  getTenants: PropTypes.func,
  getTenantsLoading: PropTypes.bool,
  tenants: PropTypes.any,
  connectToBusyLocationLoading: PropTypes.bool,
  getBusyConnectionsLoading: PropTypes.bool,
  setStep: PropTypes.func,
  getBusyConnections: PropTypes.func,
  connectToBusyLocation: PropTypes.func,
  integrationBusyId: PropTypes.any,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(BusyMapLocations));
